@if (order$ | async; as order) {
  <cx-order-overview [order]="order"></cx-order-overview>
}
